module.exports = __webpack_public_path__ + "static/media/coach-change-icon.f085fd36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/coach-change-icon.svg
// module id = 641
// module chunks = 0